import type { PaletteId } from "./types";

type RGB = [number, number, number];

const clamp01 = (value: number) => Math.min(1, Math.max(0, value));

const interpolate = (a: number, b: number, t: number) =>
  Math.round(a + (b - a) * t);

const stopsToColor = (stops: Array<[number, RGB]>, value: number): RGB => {
  const t = clamp01(value);
  for (let i = 0; i < stops.length - 1; i += 1) {
    const [leftStop, leftColor] = stops[i];
    const [rightStop, rightColor] = stops[i + 1];
    if (t >= leftStop && t <= rightStop) {
      const local = (t - leftStop) / Math.max(0.0001, rightStop - leftStop);
      return [
        interpolate(leftColor[0], rightColor[0], local),
        interpolate(leftColor[1], rightColor[1], local),
        interpolate(leftColor[2], rightColor[2], local)
      ];
    }
  }
  return stops[stops.length - 1][1];
};

export const paletteOptions: Array<{ id: PaletteId; label: string }> = [
  { id: "iron", label: "Fer" },
  { id: "rainbow", label: "Arc-en-ciel" },
  { id: "q19", label: "Q19 contraste" },
  { id: "grayscale", label: "Gris" }
];

export const getPaletteColor = (palette: PaletteId, value: number): RGB => {
  const t = clamp01(value);

  if (palette === "grayscale") {
    const v = Math.round(t * 255);
    return [v, v, v];
  }

  if (palette === "rainbow") {
    return stopsToColor(
      [
        [0, [21, 34, 92]],
        [0.18, [31, 119, 180]],
        [0.38, [36, 179, 128]],
        [0.58, [240, 213, 68]],
        [0.78, [238, 94, 44]],
        [1, [150, 28, 52]]
      ],
      t
    );
  }

  if (palette === "q19") {
    return stopsToColor(
      [
        [0, [18, 23, 32]],
        [0.18, [34, 89, 130]],
        [0.36, [20, 168, 184]],
        [0.52, [246, 220, 92]],
        [0.7, [239, 120, 45]],
        [0.86, [214, 47, 62]],
        [1, [245, 244, 238]]
      ],
      t
    );
  }

  return stopsToColor(
    [
      [0, [9, 11, 28]],
      [0.16, [56, 35, 111]],
      [0.35, [119, 42, 119]],
      [0.53, [188, 61, 74]],
      [0.72, [237, 132, 48]],
      [0.88, [249, 205, 86]],
      [1, [255, 250, 214]]
    ],
    t
  );
};

export const colorCss = ([r, g, b]: RGB) => `rgb(${r}, ${g}, ${b})`;
